import { render } from "./vue-course.vue?vue&type=template&id=1ccce498&scoped=true"
import script from "./vue-course.vue?vue&type=script&lang=js"
export * from "./vue-course.vue?vue&type=script&lang=js"

import "./vue-course.vue?vue&type=style&index=0&id=1ccce498&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccce498"]])

export default __exports__